export default {
  async enabled(params) {
    const response = await Vue.http.get('ticketing/wstrack_ami/enabled', {params})
    return response.data
  },

  async index(params) {
    const response = await Vue.http.get('ticketing/wstrack_ami', {params})
    return response.data
  }
}
